var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessageAlertSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.07989 14 5.2V8.8C14 9.9201 14 10.4802 13.782 10.908C13.5903 11.2843 13.2843 11.5903 12.908 11.782C12.4802 12 11.9201 12 10.8 12H9.1225C8.70646 12 8.49845 12 8.29948 12.0408C8.12295 12.0771 7.95213 12.137 7.79166 12.219C7.61078 12.3114 7.44834 12.4413 7.12348 12.7012L5.53317 13.9735C5.25578 14.1954 5.11708 14.3063 5.00036 14.3065C4.89885 14.3066 4.80282 14.2604 4.73949 14.1811C4.66667 14.0898 4.66667 13.9122 4.66667 13.557V12C4.04669 12 3.7367 12 3.48236 11.9319C2.79218 11.7469 2.25308 11.2078 2.06815 10.5176C2 10.2633 2 9.95331 2 9.33333V5.2Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V4.66667M8 9.33334H8.00667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageAlertSquare);
export default __webpack_public_path__ + "static/media/IconMessageAlertSquare.3ba23632ba72720025c75c7f36c0f12a.svg";
export { ForwardRef as ReactComponent };